<ng-container [ngSwitch]="headerType">
  <app-header *ngSwitchCase="'header-1'"></app-header>
  <app-header2 *ngSwitchCase="'header-2'"></app-header2>
</ng-container>

<router-outlet></router-outlet>

<app-footer></app-footer>